module.exports = __webpack_public_path__ + "static/media/favicon.c329793d.svg";